import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/General/PluginAddDeleteList";
import {PostToPbx} from "../../../../api/http-post";
import {GetFieldsAdditional} from "../../../../constants";
import {fetchDataEntity} from "../../../../api/entity-data";
import GenericComboBox from "../../../../components/General/GenericComboBox";
import {Card, Row, Col, Select, Checkbox, Button, Alert, Input, Table} from 'antd';
import "../../../../assets/css/setting.css";
import {LoadDataAnyEndpoint} from "../../../../api/fn";

const {Option} = Select;
const convertToObject=(inObj)=>{
    let ls={};
    for(let i in inObj){
        let item =inObj[i];
        ls[item]=item;
    }
    return ls
}
class SettingReportIncidentViewPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Modules: [],
            Entities: [],
            Attributes: [],
            Databases: [],
            Activities: [],
            Stages: [],
            Statuses: [],
            Priorities: [],
            isLoading: false,
            component: "list",
            newEntryFields: [],
            newEntryStatus: [],
            newEntryStage: [],
            newEntryPriority: [],
            newEntryActivity:[],
            newEntryViewName: "",
            newEntryIsDefault: false,
            newEntryPosition: 0,
            selectedCompany: "",
            selectedEntity: "",
            inputField: "",
            showList: true,

            isInAction: true,
            selectedRecord: {},
            selectedKeyName: "",
            selectedKeyValue: "",
            selectedFieldStructure: {},

        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("Projects", "Projects");
        await this.loadData("Entities", "Entities");
        await this.loadData("attributes", "Attributes");
        await this.loadData("databases", "Databases");
        await this.loadData("DatabasesView", "Data");
        await fetchDataEntity("Activities", "", "", this, undefined, "common/entity/Activities/list");
        await fetchDataEntity("Stages", "", "", this, undefined, "common/entity/Stages/list");
        await fetchDataEntity("Statuses", "", "", this, undefined, "common/entity/Statuses/list");
        await fetchDataEntity("Priorities", "", "", this, undefined, "common/entity/Priorities/list");
        await this.initializeData();
    }
    initializeData = async () => {
        let userInfo = GetUserToken();
        let paramsProject = {};
        let paramsCompany = {};
        if (userInfo.Role !== "super") {
            paramsProject = [
                {key: "Org", val: userInfo.Org, type: "string"},
            ];
            paramsCompany = [
                {key: "CustomerNumber", val: userInfo.Org, type: "string"},
            ];
        }
        await this.fetchData("companies", "Companies", paramsCompany, null);
        await this.fetchData("modules", "Projects", paramsProject, null);
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            let res = [];
            if (data !== null) {
                res = data.RESULT
            }
            await _this.setState({
                [stateKey]: res
            })
        });
    }
    fetchData = async (table, stateKey, params, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = params;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })
        await PostToPbx(post, endpoint, async (data) => {
            let res = [];
            if (data !== null) {
                res = data.RESULT;
            }
            await _this.setState({
                [stateKey]: res
            });
            console.log("fetchData response === > ", table, " > ", post, data);
            if (feedback !== null) {
                feedback(res)
            }
        });
    }
    handleChangeCompany = async (val, key) => {
        this.setState({
            [key]: val,
        });
    }
    onChangeCheck=(e)=>{
        this.setState({
            newEntryIsDefault: e.target.checked
        })
    }
    getAttributes = () => {
        let ls = [];
        for (let i in this.state.Attributes) {
            let row = this.state.Attributes[i];
            if (row.org !== this.state.selectedCompany) {
                continue
            }
            if (row.module !== this.state.selectedProject) {
                continue
            }
            ls.push(row)
        }
        return ls
    }
    formGetListOfField = () => {
        let ls = [];
        let attributes = this.getAttributes();
        for (let i in attributes) {
            let row = attributes[i];
            if (row.datatype === "list") {
                ls.push({
                    key: row.fieldname,
                    val: row.fieldname
                })
            }
        }
        return ls
    }
    requestNewView = () => {
        if (this.state.selectedCompany === "" || this.state.selectedProject === "") {
            return alert("Please select company and project before process!")
        }
        this.setState({
            component: "form",
            newEntryFields: [],
            newEntryStatus: [],
            newEntryStage: [],
            newEntryPriority: [],
        })
    }
    closeNewView = () => {
        this.setState({
            component: "list",
            newEntryFields: [],
            newEntryStatus: [],
            newEntryStage: [],
            newEntryPriority: [],
            newEntryActivity:[],
            newEntryViewName: "",
            newEntryIsDefault: false,
            newEntryPosition: 0,
        })
    }
    submitView = async () => {
        let _this =this;
        if(this.state.newEntryViewName===""){
            return alert("Sorry please provider view name!")
        }
        if(this.state.newEntryViewName===""){
            return alert("Sorry please provider view name!")
        }
        if(!window.confirm("Are you sure that you want to submit this view: "+this.state.newEntryViewName)){
            return
        }
        const getFields=()=>{
            let o={};
            if(_this.state.newEntryFields.length>0){
                o[_this.state.inputField] = JSON.stringify(this.state.newEntryFields)
            }
            return o;
        }
        let o={};
        o.Org        =this.state.selectedCompany;
        o.Module     =this.state.selectedProject;
        o.Name       =this.state.newEntryViewName;
        o.Fields     =getFields();
        o.Statutes   =convertToObject(this.state.newEntryStatus);
        o.Stages     =convertToObject(this.state.newEntryStage);
        o.Priorities =convertToObject(this.state.newEntryPriority);
        o.Activities =convertToObject(this.state.newEntryActivity);
        o.Position =parseInt(this.state.newEntryPosition);

        let hub ={...o}

        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/DatabasesView/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmit new database view send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this,async (dataOut) => {
            console.log("onSubmit new database view response > ", dataOut);
            _this.closeNewView();
            await _this.loadData("DatabasesView", "Data");
            alert("Thank you record added!")
        });

    }
    requestAction =async ( text) => {
        let _this=this;
        let table = "DatabasesView"
        if(!window.confirm("Are you sure to delete this view: "+text)){
            return
        }
        let record=null;
        let org = this.state.selectedCompany;
        let module = this.state.selectedProject;
        for(let i in this.state.Data){
            let row=this.state.Data[i];
            if(row.org!==org||row.module!==module){continue}
            if(row.name===text){
                record =null;
            }
        }

        let params=[];
        params.push({
            key: "org",
            type: "string",
            val: org
        });
        params.push({
            key: "module",
            type: "string",
            val: module
        });
        params.push({
            key: "name",
            type: "string",
            val: text
        });

        let hub = {...record};

        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = params
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/delete"; // "/manager/entity/insert/extensions";
        // let endpoint =this.props.postEndpoint; // "/manager/entity/insert/extensions";
        this.setState({
            isLoading: true,
        })
        await PostToPbx(post, endpoint, async (data) => {
             await _this.loadData(table, "Data");;
            alert("Record deleted!")
        });


    }
    renderProjectSelection = () => {

        let data = [];
        let company = this.state.selectedCompany;
        for (let i in this.state.Projects) {
            let row = this.state.Projects[i];
            console.log("&&&&--isMo> ", company, " > ", row.org)
            if (company === row.org) {
                data.push(row)
            }
        }
        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={data}
                label={"Select Project"}
                name={"selectedProject"}
                message={"Please select your project!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedProject}
                recordOptionKey={"name"}
                recordOptionValue={"name"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderCompaniesSelection = () => {

        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={this.state.Companies}
                label={"Select Company"}
                name={"selectedCompany"}
                message={"Please select your company!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedCompany}
                recordOptionKey={"customernumber"}
                recordOptionValue={"customernumber"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderCardGlobal = (title, stateNewKey, stateStorage) => {
        let _this = this;
        const onChange = (checkedValues) => {
            _this.setState({
                [stateNewKey]: checkedValues
            })
            console.log('checked = ', checkedValues);
        }

        const getCheckList = () => {
            let attributes = _this.state[stateStorage];
            let ls = [];
            for (let i in attributes) {
                const row = attributes[i];
                if (row.org !== _this.state.selectedCompany) {
                    continue
                }
                if (row.module !== _this.state.selectedProject) {
                    continue
                }
                ls.push(row.name)
            }
            return ls;
        }
        return (
            <div className="site-card-border-less-wrapper">
                <Card
                    title={title}
                    bordered={false}
                    style={{width: "100%"}}
                >
                    <Checkbox.Group style={{width: '100%'}} onChange={onChange}>
                        <Row>
                            {getCheckList().map(item => {
                                return (
                                    <Col span={24}>
                                        <Checkbox value={item}>{item}</Checkbox>
                                    </Col>
                                )
                            })}
                        </Row>
                    </Checkbox.Group>
                </Card>
            </div>
        )
    }
    renderCardField = () => {
        let options = this.formGetListOfField();
        let _this = this;
        const onChange = (checkedValues) => {
            _this.setState({
                newEntryFields: checkedValues
            })
            console.log('checked = ', checkedValues);
        }
        const handleChange2 = (e, ee) => {
            _this.setState({
                inputField: e
            })
            console.log("handleChange2 > ", e, " > ", ee)
        }
        const getCheckList = () => {
            let attributes = _this.getAttributes();
            let ls = [];
            for (let i in attributes) {
                const row = attributes[i];
                if (row.fieldname === _this.state.inputField) {
                    for (let a in row.options) {
                        ls.push(a)
                    }
                }
            }
            return ls;
        }
        return (
            <div className="site-card-border-less-wrapper">
                <Card
                    title="Database fields"
                    bordered={false}
                    style={{width: "100%"}}
                >
                    <Select
                        style={{width: "100%"}}
                        onChange={(e, ee) => handleChange2(e, ee)}
                    >
                        {options.map((record => {
                            return (
                                <Option value={record.key}>{record.val}</Option>
                            )
                        }))}
                    </Select>
                    <Checkbox.Group style={{width: '100%'}} onChange={onChange}>
                        <Row>
                            {getCheckList().map(item => {
                                return (
                                    <Col span={24}>
                                        <Checkbox value={item}>{item}</Checkbox>
                                    </Col>
                                )
                            })}
                        </Row>
                    </Checkbox.Group>
                </Card>
            </div>
        )
    }
    renderNewForm = () => {
        if (this.state.component !== "form") {
            return null
        }
        return (
            <div style={{minWidth: "100%", maxWidth: "100%", padding: 10}}>
                <Alert style={{margin: '16px 0'}} message="New Setting view incident:"/>
                <Row gutter={[16, 16]}>
                    <Col span={8}>
                        <Input
                            placeholder={"Name of view"}
                            onChange={(e) => this.handleChangeCompany(e.target.value, "newEntryViewName")}
                        />
                    </Col>
                    <Col span={8}>
                        <Input
                            placeholder={"Position"}
                            onChange={(e) => this.handleChangeCompany(e.target.value, "newEntryPosition")}
                        />
                    </Col>
                    <Col span={8}>
                        <Checkbox onChange={this.onChangeCheck}>Is Default</Checkbox>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        {this.renderCardField()}
                    </Col>
                    <Col span={12}>
                        {this.renderCardGlobal("Status", "newEntryStatus", "Statuses")}
                        {/*{this.renderCardStatus()}*/}
                    </Col>

                    <Col span={12}>
                        {this.renderCardGlobal("Stage", "newEntryStage", "Stages")}
                        {/*{this.renderCardStage()}*/}
                    </Col>
                    <Col span={12}>
                        {this.renderCardGlobal("Priority", "newEntryPriority", "Priorities")}
                    </Col>
                    <Col span={12}>
                        {this.renderCardGlobal("Activity", "newEntryActivity", "Activities")}
                    </Col>

                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={24} style={{display: "flex", flexDirection: "row", justifyContent: 'flex-end'}}>
                        <Button
                            type={"ghost"}
                            style={{color: "red", marginRight: 10}}
                            onClick={this.closeNewView}
                        >Cancel</Button>
                        <Button
                            type={"primary"}
                            style={{}}
                            onClick={()=>this.submitView()}
                        >Submit</Button>
                    </Col>
                </Row>
            </div>
        )
    }

    renderList=()=>{
        if(this.state.component!=="list"){return null}
        let columns=[];
        columns.push({
            title: "Name Of View",
            dataIndex: "name",
            render: text => <a onClick={() => this.requestAction( text)}>{text}</a>,
        });
        columns.push({
            title: "Fields",
            dataIndex: "fields",
            align: 'right',
        });
        columns.push({
            title: "Statutes",
            dataIndex: "statutes",
            align: 'right',
        });
        columns.push({
            title: "Stages",
            dataIndex: "stages",
            align: 'right',
        });
        columns.push({
            title: "Priorities",
            dataIndex: "priorities",
            align: 'right',
        });
        columns.push({
            title: "Activities",
            dataIndex: "activities",
            align: 'right',
        });
        columns.push({
            title: "Position",
            dataIndex: "position",
            align: 'right',
        });
        /*
        Fields     map[string]string
	Statutes   map[string]string
	Stages     map[string]string
	Priorities map[string]string
	Activities map[string]string
	Position float64
         */
        const objToArray=(oIn)=>{
            let lArray=[];
            for(let i in oIn){
                const v = oIn[i];
                lArray.push(v);
            }
            return lArray.map((item=>{
                return(
                    <span style={{marginLeft:10}}>
                        {item}<br/>
                    </span>
                )
            }))
        }
        const objToArray2=(oIn)=>{
            let lArray=[];
            console.log(" objToArray > ",oIn)
            for(let i in oIn){
                const v = oIn[i];
                console.log("objToArray 2 > ",i,"> ",v)
                lArray.push({key:i,val:v});
            }
            return lArray.map((item=>{
                return(
                    <span style={{marginLeft:10}}>
                        {item.key} : {item.val}<br/>
                    </span>
                )
            }))
        }
        let org = this.state.selectedCompany;
        let module = this.state.selectedProject;
        let ls=[];
        for(let i in this.state.Data){
            let row=this.state.Data[i];
            if(row.org!==org||row.module!==module){continue}
            row.fields = objToArray2(row.fields);
            row.statutes =  objToArray(row.statutes)
            row.stages =  objToArray(row.stages)
            row.priorities =  objToArray(row.priorities)
            row.activities =  objToArray(row.activities)
            ls.push(row);
        }
        return (
            <Table
                columns={columns}
                dataSource={ls}
                bordered
                /* title={() => 'Period'}*/
                /*footer={() => 'Footer'}*/
            />
        )
    }

    render() {

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                    minWidth: "100%",
                    maxWidth: "100%",
                }}>
                    <Title style={styles.title}>Setup project incident view</Title>
                    <div style={{
                        minWidth: "100%",
                        maxWidth: "100%",
                        padding: 10,
                        minHeight: 75,
                        maxHeight: 75,

                    }}>
                        <div style={{float: "left", minWidth: "30%", maxWidth: "30%"}}>
                            {this.renderCompaniesSelection()}
                        </div>
                        <div style={{float: "left", minWidth: "30%", maxWidth: "30%"}}>
                            {this.renderProjectSelection()}
                        </div>
                        <div style={{float: "left", minWidth: "30%", maxWidth: "30%"}}>
                            <Button
                                type={"dashed"}
                                style={{minWidth: "50%", marginLeft: 20}}
                                onClick={this.requestNewView}
                            >New View</Button>
                        </div>

                    </div>
                    <div style={{minWidth: "100%", maxWidth: "100%", padding: 10}}>
                        <hr/>
                    </div>

                    {this.renderNewForm()}
                    {this.renderList()}

                </div>

            </Page>
        )
    }

}


export default Connector(SettingReportIncidentViewPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
